import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'

import { useHandlers } from './hooks'
import type { ActionProps } from '../typings'

export function EditButton(props: ActionProps) {
  const {
    onClose,
    disabled,
    params: { id },
  } = props

  const { onClick } = useHandlers({ activityId: +id, onClose: onClose })

  return (
    <MenuItem
      disabled={disabled}
      onClick={onClick}
      data-test-id={`activitySummary-edit-${id}`}
    >
      Edit
    </MenuItem>
  )
}
